import { DefineModule } from 'vuex';
import StorageManager, { StorageKey } from 'managers/storage.manager';
import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  music: true,
  sfx: true,

  ...(StorageManager.load(StorageKey.SETTINGS) || {}),
};

const storeModule: DefineModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    playSfx: (state) => state.sfx,
    playMusic: (state) => state.music,
  },

  actions: {
    settingsMusic({ commit }, enabled) {
      commit('SETTINGS_MUSIC', enabled);
    },
    settingsSfx({ commit }, enabled) {
      commit('SETTINGS_SFX', enabled);
    },
  },

  mutations: {
    SETTINGS_MUSIC(state, enabled) {
      state.music = enabled;
    },
    SETTINGS_SFX(state, enabled) {
      state.sfx = enabled;
    },
  },
};

export default storeModule;
